import React from 'react';

export const SampleBadgeIn = () => {
    return (
        <span className="li-pointer-default badge badge-success ml-2 " title="is in a mag">IN</span>
    );
};